export default "__VITE_ASSET__DsXelDBu__"